<template>
  <div class="sigin-page">
    <b-container fluid class="sigin-box">
      <b-row>
        <b-col class="col">
          <b-link :to="{name: 'landing'}" style="padding-left: 24px;">
            <img src = "../assets/images/Logo_SL360_transparent.png" style="margin-bottom: 16px">
          </b-link>
          <h1 v-show="showType==='signIn'">Sign In to your SL360 account</h1>
          <h1 v-show="showType==='forgotPassword'">Forget your password</h1>
          <h1 v-show="showType==='resetPassword'">Password Reset for SL360</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="container box">
            <div v-show="showType==='signIn'">
                <b-alert :show="errorDesc!==''" variant="danger" v-html="errorDesc"></b-alert>
              <div class="form-group">
                  <label for="email">Email Address</label>
                  <b-form-input id="email"
                                v-model="user.email"
                                type="text"
                                placeholder="Enter Email Address"
                                :state ="userValid.email.state"></b-form-input>
                <span v-if="userValid.email.text" class="text-danger">{{userValid.email.text}}</span>
              </div>
              <div class="form-group">
                  <label for="password">Password</label>
                  <b-form-input id="password"
                                v-model="user.password"
                                :type="passInputType"
                                placeholder="Enter Password"
                                :state ="userValid.password.state"
                                @keyup.enter.native="signIn"></b-form-input>
              <b-link href="javascript:void(0)" @click="togglePassword" class="hide-password" :class="{ errorBtn: userValid.password.state!==null }">{{passButtonText}}</b-link>
                <span v-if="userValid.password.text" class="text-danger">{{userValid.password.text}}</span>
              </div>
              <div class="half">
                <!--<b-form-checkbox v-model="user.remember">Remember me</b-form-checkbox>-->
              </div>
              <div class="half">
                <div class="forgot-link">
                  <b-link href="javascript:void(0)" data-test="sigin-forgotpassword" @click="showType='forgotPassword'">Forgot Password?</b-link>
                </div>
              </div>
              <div class="form-group col">
                <b-btn class="sub-btn" @click="signIn">Sign In</b-btn>
              </div>
              <div class="form-group col">
                Don't have an account yet?
                <b-link :href="$store.state.config.link.signUp" dtat-test="signin-signup">Sign up.</b-link>
              </div>
            </div>
            <div v-show="showType==='forgotPassword'">
              <b-alert variant="success" :show="forgotPasswordState">
                Thank you. A temporary password has been emailed to {{sendEmail}}.
                When signIng into SL360 with your temporary password,
                you will be prompted to create a new password. If you have any questions you may contact 800-395-7707 for assistance.
              </b-alert>
              <b-alert variant="danger" :show="forgotPasswordState===false">
                Invalid Email Address
              </b-alert>
              <div class="form-group">
                <label for="rePasswordEmail">Email Address</label>
                <b-form-input id="rePasswordEmail"
                              v-model="user.email"
                              type="text"
                              placeholder="Enter Email Address"
                              :state ="emailValid.email.state"></b-form-input>
                <span v-if="emailValid.email.text" class="text-danger">{{emailValid.email.text}}</span>
              </div>
              <div class="form-group col">
                <b-btn class="sub-btn" @click="requestPassword">Request Your Password</b-btn>
              </div>
              <div class="form-group col">
                  <b-link href="javascript:void(0)" data-test="forgetpassword-signin" @click="showType='signIn'">Click here to Sign In.</b-link>
              </div>
            </div>
            <div v-show="showType==='resetPassword'">
              <h5 style="margin-bottom: 16px">Please create a new password below</h5>
              <div class="form-group">
                <label for="newPassword">Enter New Password*</label>
                <b-form-input id="newPassword"
                              v-model="newPassword"
                              type="password"
                              placeholder="Enter New Password"
                              :state ="passwordValid.newPassword.state"></b-form-input>
                <span v-if="passwordValid.newPassword.text" class="text-danger">{{passwordValid.newPassword.text}}</span>
              </div>
              <div class="form-group">
                <label for="againPassword">Re-enter Password</label>
                <b-form-input id="againPassword"
                              v-model="reNewPassword"
                              type="password"
                              placeholder="Re-enter Password"
                              :state ="passwordValid.reNewPassword.state"></b-form-input>
                <span v-if="passwordValid.reNewPassword.text" class="text-danger">{{passwordValid.reNewPassword.text}}</span>
              </div>
              <p style="color:#aaa">Must be between 10-20 characters with at least one number and one upper case letter. Passwords are case-sensitive.</p>
              <div class="form-group col">
                <b-btn class="sub-btn" @click="resetPassword" :disabled="resetDisabled">Reset</b-btn>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <m-footer></m-footer>
  </div>
</template>

<script>
  import MFooter from '@/components/layouts/MFooter'
  import notification from '@/components/common/notification'
  // import jsCookie from 'js-cookie'
  // import _ from 'lodash'

  export default {
    components: {
      MFooter
    },
    data () {
      return {
        user: {
          email: '',
          Password: '',
          remember: false
        },
        passButtonText: 'Show',
        passInputType: 'password',
        showType: 'signIn',  // forgotPassword, resetPassword, signIn
        forgotPasswordState: null,
        errorDesc: '',
        userValid: {
          email: {
            state: null,
            text: ''
          },
          password: {
            state: null,
            text: ''
          }
        },
        emailValid: {
          email: {
            state: null,
            text: ''
          }
        },
        newPassword: '',
        reNewPassword: '',
        passwordValid: {
          newPassword: {
            state: null,
            text: ''
          },
          reNewPassword: {
            state: null,
            text: ''
          }
        },
        resetDisabled: false,
        sendEmail: ''
      }
    },
    methods: {
      togglePassword () {
        if (this.passInputType === 'password') {
          this.passInputType = 'text'
          this.passButtonText = 'Hide'
        } else {
          this.passInputType = 'password'
          this.passButtonText = 'Show'
        }
      },
      validUser () {
        let isValid = true
        this.clearValid(this.userValid)
        if (this.user.email.indexOf('@') < 0 || this.user.email.indexOf('@') === this.user.email.length - 1) {
          this.userValid.email.state = false
          this.userValid.email.text = 'E-mail must be valid'
          isValid = false
        }
        if (!this.user.email) {
          this.userValid.email.state = false
          this.userValid.email.text = "It's required"
          isValid = false
        }
        if (!this.user.password) {
          this.userValid.password.state = false
          this.userValid.password.text = "It's required"
          isValid = false
        }
        return isValid
      },
      validEmail () {
        let isValid = true
        this.clearValid(this.emailValid)
        if (this.user.email.indexOf('@') < 0 || this.user.email.indexOf('@') === this.user.email.length - 1) {
          this.emailValid.email.state = false
          this.emailValid.email.text = 'E-mail must be valid'
          isValid = false
        }
        if (!this.user.email) {
          this.emailValid.email.state = false
          this.emailValid.email.text = "It's required"
          isValid = false
        }
        return isValid
      },
      signIn () {
        if (this.validUser()) {
          this.$http.post('Login.aspx/LoginUser', {
          // this.$http.get('UserLogin.ashx', {
            email: this.user.email,
            password: this.user.password
          }, {
            errorType: 'silent'
          }).then(resp => {
            this.resetDisabled = false
            let url = resp.body.d.DataSource.NextUrl
            if (url.indexOf('main/#') > -1) {
              this.$store.dispatch('user/getUserInit')
              this.$store.dispatch('user/getEditUserInfo')
              window.first.isLogin = 'ok'
              this.$root.$emit('run')
              this.$router.push({name: 'landing'})
            } else if (url.indexOf('Common/ResetPassword.aspx') > -1) {
              this.showType = 'resetPassword'
            } else {
              window.location = url
            }
          }, resp => {
            this.resetDisabled = false
            this.forgotPasswordState = false
            this.errorDesc = 'The email address or password entered is invalid.'
          })
        }
      },
      requestPassword () {
        let that = this
        if (this.validEmail()) {
          this.$http.get('GeneratePwd.ashx', {
            params: {
              email: this.user.email
            }
          }).then(resp => {
            that.forgotPasswordState = JSON.parse(resp.body.substring(8)).ResultFlag
            this.sendEmail = this.user.email
          }, resp => {
            that.forgotPasswordState = false
          })
        }
      },
      clearValid (items) {
        for (let key in items) {
          items[key].state = null
          items[key].text = false
        }
      },
      resetPassword () {
        this.clearValid(this.passwordValid)
        let isValid = true
        this.passwordValid.newPassword.text = ''

        if (this.newPassword.length < 10) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text = 'least 10 characters; '
          isValid = false
        }
        if (!(/\d/gi.test(this.newPassword))) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text += 'at least one number; '
          isValid = false
        }
        if (!(/(?=.*[A-Z])/.test(this.newPassword))) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text += 'at least one uppercase letter; '
          isValid = false
        }
        if (!(/(?=.*[a-z])/.test(this.newPassword))) {
          this.passwordValid.newPassword.state = false
          this.passwordValid.newPassword.text += 'at least one lowercase letter; '
          isValid = false
        }
        if (this.newPassword !== this.reNewPassword) {
          this.passwordValid.reNewPassword.state = false
          this.passwordValid.reNewPassword.text = 'The new passwords you\'ve entered do not match. Please re-enter.'
          isValid = false
        }

        if (!isValid) {
          return false
        }

        this.resetDisabled = true
        this.$http.post('Login.aspx/ResetPassword', {
          password: this.newPassword
        }, {
          errorType: 'silent'
        }).then(resp => {
          if (resp.body.d.DataSource) {
            this.user.password = this.newPassword
            this.signIn()
          } else {
            this.resetDisabled = false
            notification.notice('error', 'Failed to create a new password , please try again')
          }
        }, resp => {
          this.resetDisabled = false
          notification.notice('error', 'Failed to create a new password , please try again')
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .col{
    text-align: center;
  }
  .box{
    position: relative;
    width: 90%;
    max-width: 593px;
    background: #fff;
    cursor: auto;
    border-radius: 0.25em;
    box-shadow: 0px 0px 8px 0px rgba(204,204,204,1);
    text-align: left;
    padding: 20px 20px;
    margin-top: 8px;
  }
  .hide-password{
    display: inline-block;
    position: absolute;
    right: 0;
    padding: 6px 15px;
    border-left: 1px solid #d2d8d8;
    top: 48%;
    bottom: auto;
    font-size: 0.875rem;
    color: #343642;
    text-decoration: none !important;
    text-align: center;
  }
  .form-group {
    position: relative;
    margin-bottom: 2.5rem;
    clear: both;
  }
  .half {
    width: 49%;
    vertical-align: top;
    display: inline-block;
  }
  .forgot-link {
    float: right;
    display: block;
  }
  .sub-btn{
    width:210px;
  }
  .error-btn {
    top:38%;
  }
  .success-msg {
    color: #4F8A10;
    background-color: #DFF2BF;
    margin: 10px 22px;
    font-size: 1.5rem;
    padding: 10px;
    vertical-align: middle;
  }
  .sigin-box {
    padding-top: 48px;
  }
  .sigin-page {
    min-height: 100vh;
    background-color: $color-body;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }
</style>



// WEBPACK FOOTER //
// src/pages/SignIn.vue